import { render, staticRenderFns } from "./ResultText.vue?vue&type=template&id=3b1c2e97"
import script from "./ResultText.vue?vue&type=script&lang=js"
export * from "./ResultText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports